
    <info-drawer [title]="'translate.add-doc-metadata.metadata' | translate"
    [buttonLabel]="'translate.doc-metadata.show-all' | translate"
        [items]="metadataItems"
        [loading]="!resolved"
        [showEdit]="isEditable()"
        [saving]="saving"
        (showDrawer)="showDrawer()"
        (itemChange)="onItemValueChange($event.item, $event.value)"
        (discardChanges)="discardChanges()"
        (saveChanges)="saveChanges($event)">
    </info-drawer>

